import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import {
    persistReducer, persistStore, FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER, } from 'redux-persist';
 import {thunk} from 'redux-thunk';

// slice
import toogleSlice from "./slices/changeMenuStateSlice";
import languageSlice from './slices/changeLanguageSlice';
import currencySlice from './slices/changeCurrencySlice';
// import gameCategoriesSlice from './slices/GameCategoriesSlice';
import userDetailSlice from './slices/UserDetailSlice.js';
import providerSlice from './slices/ProviderSlice';
import gameSlice from './slices/GameSlice';

 const persistConfig = {
    key: 'root',
    storage,
}
const rootReducer = combineReducers({
    menuState: toogleSlice,
    languageState: languageSlice,
    currencyState: currencySlice,
    // gameCategoryState: gameCategoriesSlice,
    userDetailState: userDetailSlice,
    providerState: providerSlice,
    gameState: gameSlice
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
    // middleware: (getDefaultMiddleware) =>
    // getDefaultMiddleware({
    //   serializableCheck: {
    //     ignoredActions: [thunk],
    //   },
    // }),
})

export const persistor = persistStore(store)

export default store


